/**
 * useModalStore
 */
import { useCallback, useMemo } from 'react';
import {
    Queries,
    ApolloLib,
    Mutations,
} from 'bdvp-graphql';

const { useMutation, useQuery } = ApolloLib;
const { GET_MODALS } = Queries;
const {
    MODAL_SHOW,
    MODAL_HIDE,
    MODAL_TOGGLE,
} = Mutations;

const useModalStore = (options = {}) => {

    const  {
        showOptions = {},
        hideOptions = {},
        toggleOptions = {},
    } = options;
    const {
        data = {
            modals: '{}',
        },
    } = useQuery(GET_MODALS);
    const parsedModals = useMemo(() => JSON.parse(data.modals), [data]);

    const [modalShow] = useMutation(MODAL_SHOW, showOptions);
    const [modalHide] = useMutation(MODAL_HIDE, hideOptions);
    const [modalToggle] = useMutation(MODAL_TOGGLE, toggleOptions);

    const isModalOpen = useCallback(modal => (parsedModals[modal] || false), [parsedModals]);
    const _modalShow = useCallback(modal => modalShow({ variables: { name: modal } }), [modalShow]);
    const _modalHide = useCallback(modal => modalHide({ variables: { name: modal } }), [modalHide]);
    const _modalToggle = useCallback(modal => modalToggle({ variables: { name: modal } }), [modalToggle]);

    return {
        isModalOpen,
        modalShow: _modalShow,
        modalHide: _modalHide,
        modalToggle: _modalToggle,
        modals: parsedModals,
    };

};

export default useModalStore;
